import React, { useCallback } from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './TitanWithoutDomainModal.styles';
import useLocale from '@/hooks/useLocale';
import { useHistory } from 'react-router';
import { useResize } from '@/hooks/useResize';

const TitanWithoutDomainModal = ({
  onClose,
  displayTitanWithoutDomainModal,
}) => {
  const { titanWithoutDomain: titanWithoutDomainLocale, routes: routesLocale } = useLocale();
  const history = useHistory();
  const windowRect = useResize();
  const { width } = windowRect;
  const { recoverFreeDomainId, recoverFreeDomainTld, hostingId } = displayTitanWithoutDomainModal;

  const isFreeDomainRedeem = Boolean(recoverFreeDomainId);

  const modalContent = isFreeDomainRedeem ? titanWithoutDomainLocale.startModalFreeDomain : titanWithoutDomainLocale.startModal;

  const mobile = width < 600;

  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  const handleRedirectToTitanWithoutDomain = useCallback(() => {
    const routePath = isFreeDomainRedeem ? `${routesLocale.domains}${routesLocale.registerDomain}` : `${routesLocale.emailsList + routesLocale.changeDomain}/${hostingId}`;


    history.push(routePath, { recoverFreeDomainId });
  }, [history, routesLocale, hostingId, recoverFreeDomainId, isFreeDomainRedeem]);

  return (
    <Modal
      maxWidth={500}
      open
      onClose={handleClose}
      title={modalContent.title}
      testId="modal-titan-without-domain"
      mobileMaxHeight="fit-content"
      alignModal={mobile ? 'end' : 'center'}
    >
      <Styles.Content>{modalContent.description(recoverFreeDomainTld)}</Styles.Content>
      <Styles.ButtonWrapper>
        <Button onClick={handleRedirectToTitanWithoutDomain} size="large" label={modalContent.buttonLabel} width={mobile ? 'full' : 'fit'} />
      </Styles.ButtonWrapper>
    </Modal>
  );
};

export default TitanWithoutDomainModal;
